import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/UI'
import { materialCalculatorApi } from '../../services/materialCalculator'
import MCRulesetParamsTable from './components/MCRulesetParamsTable'

export default function MCRulesetDetailPage() {
  const { rulesetId } = useParams()
  const [ruleset, setRuleset] = useState(null)

  const load = () => materialCalculatorApi.getRuleset(rulesetId).then(setRuleset).catch(() => setRuleset(null))
  useEffect(load, [rulesetId])

  const handleOverride = async (paramKey, value) => {
    await materialCalculatorApi.overrideParameter(rulesetId, paramKey, { paramValue: value, reason: 'Ajuste manual desde la interfaz' })
    load()
  }

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>{ruleset?.ruleKey} {ruleset?.version}</CardTitle>
          <CardDescription>Fuente: {ruleset?.sourceTitle}</CardDescription>
        </CardHeader>
        <CardContent>
          <MCRulesetParamsTable ruleset={ruleset} onOverride={handleOverride} />
        </CardContent>
      </Card>
    </div>
  )
}
